import { getObjectModule, ObjectsType } from './get.module';

const module = getObjectModule(ObjectsType.Cars);
export default module;
